import * as types from "./actionTypes";

export const getList = pageNumber => {
  return {
    type: types.NOTICE_LIST_REQUEST,
    pageNumber
  };
};

export const getListSuccess = data => {
  return {
    type: types.NOTICE_LIST_SUCCESS,
    payLoad: data
  };
};

export const getListFailure = error => {
  return {
    type: types.NOTICE_LIST_FAILURE,
    error: error
  };
};

export const read = (id, type, action) => {
  return {
    type: types.NOTICE_READ_REQUEST,
    id: id,
    noticeType: type,
    action: action
  };
};
export const readSuccess = (id, isSeen) => {
  return {
    type: types.NOTICE_READ_SUCCESS,
    id: id,
    isSeen: isSeen
  };
};

export const readFailure = (id, isSeen) => {
  return {
    type: types.NOTICE_READ_FAILURE,
    id: id,
    isSeen: isSeen
  };
};

export const remove = id => {
  return {
    type: types.NOTIFICATION_REMOVE_REQUEST,
    id: id
  };
};
export const removeSuccess = id => {
  return {
    type: types.NOTIFICATION_REMOVE_SUCCESS,
    id: id
  };
};

export const removeFailure = id => {
  return {
    type: types.NOTIFICATION_REMOVE_FAILURE,
    id: id
  };
};

export const setNotificationCount = countObject => {
  return {
    type: types.SET_NOTIFICATION_COUNT,
    payLoad: countObject
  };
};
